'use client';
import { useState } from 'react';
import { useEffect } from "react";


export default function GetSidemenuFlag() {

    const [open, setOpen] =  useState (false);
    

    useEffect(() => {
        const updateMenuState = () => {
            const ismenuOpen = localStorage.getItem("ismenuOpen") === 'true';
            setOpen(ismenuOpen);
        };

        // Initial load
        updateMenuState();

        // Listen to custom event
        window.addEventListener("sidemenuToggle", updateMenuState);

        return () => {
            window.removeEventListener("sidemenuToggle", updateMenuState);
        };
    }, []);
    

    return(
        <div className={`sidemenustate ${open==true ? "show":"hide"}`}></div>        
    )
}
 